module.exports = __webpack_public_path__ + "static/card-img-2-5c94f50ae5ed036e2bbca5adffed0ccb.jpg";